var map = {
	"./Blaziken.png": 5337,
	"./Cinderace.png": 6047,
	"./Clefable.png": 1503,
	"./Clodsire.png": 4760,
	"./Eelektross.png": 1178,
	"./Empoleon.png": 5008,
	"./Grimmsnarl.png": 2515,
	"./Infernape.png": 7649,
	"./Leavanny.png": 9245,
	"./Quagsire.png": 5742,
	"./Revavroom.png": 5355,
	"./Samurott-hisui.png": 9293,
	"./Sceptile.png": 458,
	"./Skeledirge.png": 9124,
	"./Sneasler.png": 6838,
	"./Stoutland.png": 3527,
	"./flareon.png": 4632,
	"./gardevoir.png": 5532,
	"./porygon-z.png": 878,
	"./rotom.png": 9532,
	"./sirfetchd.png": 6049
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8486;